"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionMenuLabelsUnassignButton = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const standard_button_1 = require("../buttons/standard-button");
exports.ActionMenuLabelsUnassignButton = (0, styled_components_1.default)(standard_button_1.StandardButton) `
  display: block;
  min-width: 40px;
  margin: 10px 5px 0px 5px;
`;
//# sourceMappingURL=action-menu-labels-unassign-button.js.map